import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import PromotionRowNew from '@/components/buybox-new/PromotionRowNew.vue';
import { computed, ref } from 'vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import BuyBoxFreeTrialSwiperOSContainer from './BuyBoxFreeTrialSwiperOSContainer.vue';
import { freeTrialSwiperRules, SwiperRule } from '@/helpers/promotion-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { UsePromotion } from '@/helpers/composables/usePromotion';
import { OfferLocation } from '@/helpers/offer-helper';
import { useGeoSwiper } from '@/components/buybox/composables/useGeoSwiper';

interface ClickoutPayload {
	buyboxOffer: UsePromotion['promotionOffer'];
	offerLocation: OfferLocation.FREE_TRIAL;
	row: HTMLElement | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxFreeTrialSwiperOS',
  props: {
    offers: null,
    title: null
  },
  emits: ["clickOut"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'clickOut', payload: ClickoutPayload): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	offers: Offer[];
	title: TitleDetail;
};





const { country } = useLanguageStore();

const { geoLocation } = useGeoSwiper({ title: () => props.title });

const freeTrialSwiperActive = computed(() => {
	return freeTrialSwiperRules[country.value] != null;
});

const freeTrialSwiperConfig = computed<SwiperRule | null>(() => {
	return freeTrialSwiperRules[country.value] ?? null;
});

const swiperPackages = computed(() => {
	const allPackages = freeTrialSwiperConfig.value?.packages || [];

	return allPackages.map(pkg => {
		const hasMatchingGeoLocation = freeTrialSwiperConfig.value?.rules.find(
			rule => rule.id === pkg.id && rule.selectors.geoLocations.includes(geoLocation.value || '')
		);

		return {
			...pkg,
			activeGeoLocation: hasMatchingGeoLocation ? geoLocation.value : null,
		};
	});
});

const swipeIndex = ref(0);

const isShowOrSeason = computed(() => ['Show', 'Season'].includes(props.title.__typename));

const slideDelay = computed(() => freeTrialSwiperConfig.value?.slideDelay ?? 1500);

const slideToPackageId = computed(() => {
	if (freeTrialSwiperConfig.value == null) return null;

	const ruleWithActiveGeoLocation = freeTrialSwiperConfig.value.rules.find(
		rule => rule.selectors.geoLocations[0] === geoLocation.value
	);

	if (ruleWithActiveGeoLocation) {
		return ruleWithActiveGeoLocation.id;
	}

	return freeTrialSwiperConfig.value.default.id;
});

const swiperSlideToIndex = computed(() => {
	if (swiperPackages.value == null || slideToPackageId.value == null) return 0;

	return Math.max(
		0,
		swiperPackages.value.findIndex(el => el.id === slideToPackageId.value)
	);
});

function handleClickout(payload: ClickoutPayload, geoCountry: string | undefined, index: number) {
	const countryOrGeoCountry = geoCountry ?? country.value;

	TrackingHelper.trackEvent('userinteraction', {
		action: 'click',
		label: `free_trial_${countryOrGeoCountry}`,
		property: 'geo_swiper',
		value: index,
	});

	emit('clickOut', payload);
}

function slideChange({
	direction,
	position,
	skipTracking,
	nonInteraction,
}: {
	direction: string;
	position: number;
	skipTracking: boolean;
	nonInteraction: boolean;
}) {
	const parsedInitialPosition = Number(swipeIndex.value);
	const initialPosition = isNaN(parsedInitialPosition) ? undefined : parsedInitialPosition;

	const category = nonInteraction ? 'automation' : 'userinteraction';
	const action = nonInteraction ? 'auto_swipe' : 'swipe_clicked';

	swipeIndex.value = position;

	if (!skipTracking) {
		TrackingHelper.trackEvent(category, {
			action,
			label: direction,
			nonInteraction,
			value: initialPosition,
			property: 'geo_swiper',
		});
	}
}

return { __sfc: true,props, emit, country, geoLocation, freeTrialSwiperActive, freeTrialSwiperConfig, swiperPackages, swipeIndex, isShowOrSeason, slideDelay, slideToPackageId, swiperSlideToIndex, handleClickout, slideChange, PromotionRowNew, BuyBoxFreeTrialSwiperOSContainer }
}

})